"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1788))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.624Z
 */
export const Dollar = createSVGIcon(
  <>
    <path
      d="M0.5 12.5C0.5 15.6826 1.76428 18.7348 4.01472 20.9853C6.26516 23.2357 9.3174 24.5 12.5 24.5C15.6826 24.5 18.7348 23.2357 20.9853 20.9853C23.2357 18.7348 24.5 15.6826 24.5 12.5C24.5 9.3174 23.2357 6.26516 20.9853 4.01472C18.7348 1.76428 15.6826 0.5 12.5 0.5C9.3174 0.5 6.26516 1.76428 4.01472 4.01472C1.76428 6.26516 0.5 9.3174 0.5 12.5V12.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.051 20.0011C12.051 20.2761 12.274 20.499 12.5489 20.499C12.8239 20.499 13.0468 20.2761 13.0468 20.0011V18.3556C15.2409 18.2205 16.8105 16.7353 16.8105 14.8113C16.8105 12.634 15.5278 11.8408 13.0468 11.402V7.18257C14.1097 7.3262 14.7692 7.83651 15.0981 8.78633C15.2043 9.09283 15.475 9.32603 15.7994 9.32603C16.2036 9.32603 16.524 8.97114 16.4133 8.58239C15.9848 7.07768 14.8005 6.19564 13.0468 6.03489V4.99691C13.0468 4.72194 12.8239 4.49902 12.5489 4.49902C12.274 4.49902 12.051 4.72194 12.051 4.99691V6.01801C9.94134 6.15303 8.48986 7.52012 8.48986 9.27539C8.48986 11.3007 9.8232 12.094 12.051 12.5159V17.2079C10.322 17.052 9.75926 16.2059 9.52335 15.1592C9.44453 14.8094 9.14962 14.5412 8.79114 14.5412C8.36838 14.5412 8.03295 14.9094 8.12949 15.321C8.5028 16.9126 9.56053 18.1808 12.051 18.3556V20.0011ZM9.8232 9.14037C9.8232 8.09396 10.6333 7.28383 12.051 7.16569V11.2332C10.1776 10.845 9.8232 10.2037 9.8232 9.14037ZM15.4097 14.9125C15.4097 16.1615 14.397 17.0729 13.0468 17.2079V12.6847C14.8865 13.0729 15.4097 13.6636 15.4097 14.9125Z"
      fill="currentColor"
    />
  </>,
  "Dollar",
  { viewBox: "0 0 25 25", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
